import { qz } from '@packages/nuacare-qz-tray';
import { isValidTextAndNotEmpty } from './CommonUtil';

export const REGISTERED_MACHINE_DETAILS = 'registeredMachineDetails';

export const persistRegisteredMachineDetails = async (registeredMachineDetails) => {
    localStorage.setItem(REGISTERED_MACHINE_DETAILS, JSON.stringify(registeredMachineDetails));
};

export const getRegisteredMachineDetails = () => {
    const registeredMachineDetailsString = localStorage.getItem(REGISTERED_MACHINE_DETAILS);
    if (isValidTextAndNotEmpty(registeredMachineDetailsString)) {
        try {
            return JSON.parse(registeredMachineDetailsString);
        } catch (error) {
            console.error('Unable to parse registeredMachineDetails', registeredMachineDetailsString);
            return null;
        }
    }
    return null;
};

export const evictRegisteredMachineDetails = () => {
    localStorage.removeItem(REGISTERED_MACHINE_DETAILS);
};

export const fetchMachineId = async (printConnectConfig) => {
    if (!qz.websocket.isActive()) {
        await qz.websocket.connect(printConnectConfig);
    }
    const machineId = await qz.getMachineId();
    if (!isValidTextAndNotEmpty(machineId) || machineId === 'UNKNOWN') {
        return null;
    }
    return machineId;
};

export const fetchMachineIdSilently = async (printConnectConfig) => {
    let machineId;
    try {
        machineId = await fetchMachineId(printConnectConfig);
    } catch (error) {
        machineId = null;
        console.error('Error In getting machine id', error);
    }
    return machineId;
};
